import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export interface BreadcrumbItem {
  text: string;
  to?: string;
}

/** govuk/components/breadcrumbs (wrapped in a labelled nav landmark). */
export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  const { t } = useTranslation();
  return (
    <nav className="govuk-breadcrumbs" aria-label={t('layout.breadcrumbs')}>
      <ol className="govuk-breadcrumbs__list">
        {items.map((item, i) =>
          item.to ? (
            <li className="govuk-breadcrumbs__list-item" key={i}>
              <Link className="govuk-breadcrumbs__link" to={item.to}>
                {item.text}
              </Link>
            </li>
          ) : (
            <li className="govuk-breadcrumbs__list-item" aria-current="page" key={i}>
              {item.text}
            </li>
          ),
        )}
      </ol>
    </nav>
  );
}
